import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useRef, useState } from 'react';
export function useResizeObserver(targetRef) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    contentRect = _useState2[0],
    setContentRect = _useState2[1];
  var resizeObserver = useRef(null);
  useEffect(function () {
    if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
      observe(ResizeObserver);
    }
    function observe(Observer) {
      resizeObserver.current = new Observer(function (entries) {
        if (entries) {
          setContentRect(function () {
            return copy(entries[0].contentRect);
          });
        }
      });
      if (targetRef.current) {
        resizeObserver.current.observe(targetRef.current);
      }
    }
    return disconnect;
  }, [targetRef]);
  function disconnect() {
    if (resizeObserver.current) {
      resizeObserver.current.disconnect();
    }
  }
  return contentRect;
}
function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}